<div class="modal-overlay">
  <div class="card mx-auto border-0">
    <div class="card-header bergh-bg-primary text-white h5">
      Waarschuwingsbericht
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          @if (isLink==='Delink') {
          <span class="size"
            >Wilt u de brandpartitie ontkoppelen uit dit document?</span
          >
          } @if (isLink==='Link') {
          <span class="size"
            >Wilt u de brandpartitie koppelen uit dit document?</span
          >
          } @if (popUpAllType==='Delink') {
          <span class="size"
            >Wil je deze brandpartitie(s) ontkoppelen uit dit document?</span
          >
          } @if (popUpAllType==='Link') {
          <span class="size"
            >Wilt u deze brandpartitie(s) koppelen uit dit document?</span
          >
          }
        </div>
      </div>
    </div>
    <div class="card-footer bg-white d-flex justify-content-end">
      @if (isLink==='Link') {
      <button
        class="btn btn-secondary mr-2 col-4"
        (click)="isConfirmLink.emit(true)"
        id="btn_move"
      >
        Koppelen
      </button>
      } @if (isLink==='Delink') {
      <button
        class="btn btn-secondary mr-2"
        (click)="isConfirmUnlink.emit(true)"
        id="btn-cancel"
      >
        Ontkoppelen
      </button>
      } @if (popUpAllType==='Link') {
      <button
        class="btn btn-secondary mr-2 col-4"
        (click)="isConfirmAllLink.emit(true)"
        id="btn_move"
      >
        Alles koppelen
      </button>
      } @if (popUpAllType==='Delink') {
      <button
        class="btn btn-secondary mr-2"
        (click)="isConfirmAllUnlink.emit(true)"
        id="btn-cancel"
      >
        Alles ontkoppelen
      </button>
      }
      <button
        class="btn btn-secondary mr-2"
        (click)="cancel.emit(false)"
        id="btn-cancel"
      >
        Nee
      </button>
    </div>
  </div>
</div>
